var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-item-section',{staticClass:"submenu-indicator",attrs:{"side":""}},[_c('q-icon',{attrs:{"name":"mib-arrow-right-1","size":"0.6em"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }